import { render, staticRenderFns } from "./NavigationContext.vue?vue&type=template&id=bb658bd8&scoped=true"
import script from "./NavigationContext.vue?vue&type=script&lang=js"
export * from "./NavigationContext.vue?vue&type=script&lang=js"
import style0 from "./NavigationContext.vue?vue&type=style&index=0&id=bb658bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb658bd8",
  null
  
)

export default component.exports